<template>
  <div class="view-wrapper">
    <div class="view">
      <v-card>
        <v-card-title style="padding: 4px 16px">
          <h6>Фильтр</h6>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row dense>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.startDate"
                  label="С"
                  type="date"
                  required
                  clearable

                  @keydown.enter="fetchItems"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.endDate"
                  label="По"
                  type="date"
                  required
                  clearable

                  @keydown.enter="fetchItems"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pl-4">
                <v-radio-group
                  v-model="filter.ratio"
                  row mandatory
                >
                  <v-radio
                    label="Услуги SOSMA"
                    color="red"
                    value="sosma"
                  ></v-radio>
                  <v-radio
                    label="Сторонние клиники"
                    color="green"
                    value="other"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="fetchItems">
            Применить
          </v-btn>
          <v-btn small @click="resetFilter">
            Сбросить
          </v-btn>
          <v-spacer />
          <v-btn
            color="green"
            :loading="exporting"
            :disabled="items.length === 0"
            small
            class="white--text"
            @click="exp"
          >
            Экспорт
            <v-icon right dark>
              cloud_download
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :single-select="true"
        item-key="id"
        hide-default-footer
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
        fixed-header
      >

      </v-data-table>
    </div>
  </div>
</template>

<script>

import dateIsoFilter from "@/filters/dateIso.filter";
import js2vm from "@/utils/js2vm";
import ctx from "@/ctx";
import fetch from "@/utils/fetch";
import vm2js from "@/utils/vm2js";

let Filter = function() {
  let self = this;

  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  self.startDate = dateIsoFilter(startDate);
  self.endDate = dateIsoFilter(new Date());
};


let Item = function(d) {
  let self = this;

  js2vm(self, d);
  self.startDate = dateIsoFilter(d.startDate);
  self.endDate = dateIsoFilter(d.endDate);

}

let Report = function(d) {
  let self = this;

  self.title = d.title;
  self.subtitle = d.subtitle;
  self.rowDtos = [];

  d.rowDtos.forEach(i => {
    self.rowDtos.push(new Item(i));
  });
};

export default {
  data: () => ({
    ctx,
    selected: [],
    loading: false,
    headers: [
      {
        text: "Наименование страхователя",
        align: "start",
        sortable: false,
        value: "fullName"
      },
      {
        text: "№ договора",
        sortable: false,
        value: "number"
      },
      {
        text: "Медицинские услуги ТОО \"SOS Medical Assistance\", тенге",
        sortable: true,
        value: "amount"
      },
      {
        text: "Сумма total",
        sortable: false,
        value: "increasedAmount"
      }

    ],
    report: {},
    filter: new Filter(),
    items: [],
    exporting: false
  }),
  methods: {
    resetFilter() {
      this.filter = new Filter();
    },
    async exp() {
      this.exporting = true;
      try {
        const res = await fetch.post(
          "/api/report/appendix-4/export",
          vm2js(this.report)
        );
        if (res) {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(await res.blob);
          link.download = res.filename;
          link.click();
        }
      } finally {
        this.exporting = false;
      }
    },
    async fetchItems() {
      this.loading = true;
      this.items = [];
      try {
        let res = await fetch.post(
          "/api/report/appendix-4/get",
          vm2js(this.filter)
        );
        if (res) {
          this.report = new Report(res);
          res.rowDtos.forEach(r => {
            this.items.push(new Item(r));
          });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>

</style>
